import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  value: number;
  title?: string;
};

export const NumberDisplay: React.FC<IProps> = ({ value, title }) => {
  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      <Text textStyle="textBody">{value}</Text>
    </Flex>
  );
};
